import { render, staticRenderFns } from "./VDealClientsMinimal.vue?vue&type=template&id=d75370a4&scoped=true"
import script from "./VDealClientsMinimal.vue?vue&type=script&lang=js"
export * from "./VDealClientsMinimal.vue?vue&type=script&lang=js"
import style0 from "./VDealClientsMinimal.vue?vue&type=style&index=0&id=d75370a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75370a4",
  null
  
)

export default component.exports